import { render, staticRenderFns } from "./SupplierDeadlineReport.vue?vue&type=template&id=2d2f160c&"
import script from "./SupplierDeadlineReport.vue?vue&type=script&lang=js&"
export * from "./SupplierDeadlineReport.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDeadlineReport.vue?vue&type=style&index=0&id=2d2f160c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports